import ImportForm from '@app/components/apps/Import/ImportForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';

const CreateImportPage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Import Task');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const ImportType = localStorage.getItem('selected_import_type') || 'NORMAL';

  const importTypeMap: Record<string, { name: string; route: string }> = {
    NORMAL: { name: 'Imports - Normal', route: '/import/normal' },
    NON_COMPLIANCE_1: { name: 'Imports: Non-Compliance 1', route: '/import/non-compliance-1' },
    NON_COMPLIANCE_3: { name: 'Imports: Non-Compliance 3', route: '/import/non-compliance-3' },
    NO_OBJECTION: { name: 'Imports - No Objection', route: '/import/no-objection' },
    NON_RELEVANT: { name: 'Imports: Non-Relevant', route: '/import/non-relevant' },
  };

  const selectedImport = importTypeMap[ImportType] || importTypeMap.NORMAL;

  const routes = [
    {
      path: selectedImport.route,
      breadcrumbName: selectedImport.name,
    },
    {
      path: '/import/add-import',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName, ImportType]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ImportForm
          editable={true}
          pageTitle={'Create import'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default CreateImportPage;
